module.exports = __webpack_public_path__ + "img/search_nodata.38169910.svg";